import React from 'react';
import './styles/index.css';
import SiteButton from '../../ui/Button/siteButtons';

const Banner = ({ cloudFront, history, signupLink }) => (
  <section className="banner-container">
    <div className="piller mx-auto">
      <div className="homepage-banner-content">
        <h1 className="darkTxt weight-500">
          Grow your programming skills through <span className="d-inline-block homepage-special-text text-inheritance">visualization</span>
        </h1>
        <p className="banner-subtitle" style={{ paddingBottom: '25px' }}>
          Learn programming, data structures & algorithms, and prepare for the interview - all in one place.
        </p>
        <SiteButton bannerBtn onClick={() => history.push(signupLink)}>
          Join for free
        </SiteButton>
      </div>
      <div className="homepage-banner-video-container">
        <div className="embed-responsive embed-responsive-16by9 homepage-banner-video">
          <object className="no-pointers" data={cloudFront + '/Assets/homePage/HomePageBannerNew.svg'}>
            Banner image
          </object>
        </div>
      </div>
    </div>
  </section>
);

export default Banner;
